import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';

Home[$.FILENAME] = 'src/web/home.svelte';

import * as $ from 'svelte/internal/client';
import Logo from "./logo.svelte";

var root = $.add_locations(
	$.from_html(
		`
    <a class="font-display text-lg font-semibold tracking-tight opacity-60 hover:opacity-100 transition-opacity"> </a>
  `,
		1
	),
	Home[$.FILENAME],
	[[19, 4]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
    <section class="min-h-dvh flex items-center justify-center px-5 md:px-10">
      <h2 class="font-display text-4xl md:text-6xl font-semibold tracking-tight"> </h2>
    </section>
  `,
		1
	),
	Home[$.FILENAME],
	[[34, 4, [[35, 6]]]]
);

var root_2 = $.add_locations(
	$.from_html(
		`

<header class="absolute top-0 inset-x-0 p-5 md:p-10 flex items-center justify-center gap-3 md:gap-4">
  <!>
  <span class="font-display text-3xl md:text-5xl font-semibold tracking-tight leading-none">CreaGeen</span>
</header>

<nav class="fixed inset-y-0 left-0 p-5 md:p-10 hidden md:flex flex-col justify-center gap-4">
  <!>
</nav>

<main>
  <section id="home" class="min-h-dvh flex flex-col items-center justify-center gap-6 md:gap-8 px-5 md:px-10 py-28 text-center">
    <h1 class="max-w-6xl font-display text-5xl md:text-7xl lg:text-8xl font-semibold tracking-tight leading-[1.05]">
      We create your<br/>company's own OS*
    </h1>
    <p class="max-w-2xl font-display text-sm md:text-base opacity-60">
      *the software your whole company runs on
    </p>
  </section>

  <!>
</main>`,
		1
	),
	Home[$.FILENAME],
	[
		[12, 0, [[14, 2]]],
		[17, 0],
		[23, 0, [[24, 2, [[25, 4, [[26, 20]]], [28, 4]]]]]
	]
);

function Home($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, false, Home);

	const sections = [
		{ id: "home", label: "Home" },
		{ id: "process", label: "Process" },
		{ id: "work", label: "Work" },
		{ id: "contact", label: "Contact" }
	];

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_2();
	var header = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(header));

	$.add_svelte_meta(() => Logo(node, { class: 'size-12 md:size-20' }), 'component', Home, 13, 2, { componentTag: 'Logo' });
	$.next(3);
	$.reset(header);

	var nav = $.sibling(header, 2);
	var node_1 = $.sibling($.child(nav));

	$.add_svelte_meta(
		() => $.each(node_1, 1, () => sections, $.index, ($$anchor, section) => {
			$.next();

			var fragment_1 = root();
			var a = $.sibling($.first_child(fragment_1));
			var text = $.only_child(a, true);

			$.next();

			$.template_effect(() => {
				$.set_attribute(a, 'href', `#${$.get(section).id ?? ''}`);
				$.set_text(text, $.get(section).label);
			});

			$.append($$anchor, fragment_1);
		}),
		'each',
		Home,
		18,
		2
	);

	$.next();
	$.reset(nav);

	var main = $.sibling(nav, 2);
	var node_2 = $.sibling($.child(main), 3);

	$.add_svelte_meta(
		() => $.each(node_2, 1, () => sections.slice(1), $.index, ($$anchor, section) => {
			$.next();

			var fragment_2 = root_1();
			var section_1 = $.sibling($.first_child(fragment_2));
			var h2 = $.sibling($.child(section_1));
			var text_1 = $.only_child(h2, true);

			$.next();
			$.reset(section_1);
			$.next();

			$.template_effect(() => {
				$.set_attribute(section_1, 'id', $.get(section).id);
				$.set_text(text_1, $.get(section).label);
			});

			$.append($$anchor, fragment_2);
		}),
		'each',
		Home,
		33,
		2
	);

	$.next();
	$.reset(main);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Home = $.hmr(Home);

	import.meta.hot.accept((module) => {
		Home[$.HMR].update(module.default);
	});
}

export default Home;